// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"a8cb4d40","748":"d1f283ee","851":"4f02dbb6","865":"6911fe3a"}[chunkId] + ".chunk.js";
};